import '../../../../../node_modules/@glidejs/glide/dist/css/glide.core.css'
import '../../../../../node_modules/@glidejs/glide/dist/css/glide.theme.css'
import Glide from '@glidejs/glide'

const gallery = {
  elThumbnailSlider: '',
  init() {
    this.elThumbnailSlider = $q('.bb-section--home-gallery .thumbnail-slider')

    if (!this.elThumbnailSlider.first) return

    new Glide(this.elThumbnailSlider.first, {
      type: 'carousel',
      gap: 15,
      perView: 3,
      peek: {
        before: 0,
        after: 300
      },
      breakpoints: {
        1024: {
          perView: 2,
          peek: {
            before: 0,
            after: 100
          }
        },
        600: {
          perView: 1,
          peek: {
            before: 0,
            after: 100
          }
        }
      }
    }).mount()

    this.elThumbnailSlider.listen('mousemove', () => document.body.classList.add('js-pointer'))
    this.elThumbnailSlider.listen('mouseleave', () => document.body.classList.remove('js-pointer'))
  }
}

export default gallery
